import { ShowButton as RaShowButton } from 'react-admin'

export function ShowButton(props) {
  return <RaShowButton label="Show" {...props} />
}
